module.exports = __webpack_public_path__ + "static/media/U region split.f50278d5.kra";